import { gql } from "@apollo/client";
export default gql`
  mutation EnrolUser {
    enrolUser
  }
`;
